import React from 'react'
import Helmet from 'react-helmet'
import PageWrapper from '../components/PageWrapper/PageWrapper'
import Inner from '../components/Inner/Inner'
import TextContainer from '../components/TextContainer/TextContainer'
import InputButton from '../components/InputButton/InputButton'
import Divider from '../components/Divider/Divider'
import FaFacebookOfficial from 'react-icons/lib/fa/facebook-official'
import Careers from '../components/Careers/Careers'
import styles from './ContactPage.module.css'

class ContactPage extends React.Component {
  state = {
    contact_type: 'sales',
  }

  handleChange = e => {
    const target = e.target
    const value = target.value
    const name = target.name

    this.setState({ [name]: value })
  }

  render() {
    function RenderForm(props) {
      const contact_type = props.contact_type
      if (props.contact_type == 'sales') {
        return (
          <form name="contact_sales" method="POST" data-netlify="true">
            <input type="hidden" name="form-name" value="contact_sales" />
            <p>
              <label htmlFor="name_sales">Name:</label>
              <br />
              <input type="text" id="name_sales" name="name" />
            </p>
            <p>
              <label htmlFor="email_sales">Email:</label>
              <br />
              <input type="text" id="email_sales" name="email" />
            </p>
            <p>
              <label htmlFor="phone_sales">Phone:</label>
              <br />
              <input type="text" id="phone_sales" name="phone" />
            </p>
            <p>
              <label htmlFor="message_sales">Message:</label>
              <br />
              <textarea id="message_sales" name="message" />
            </p>
            <InputButton title="Submit" />
          </form>
        )
      }
      if (props.contact_type == 'technical') {
        return (
          <form name="contact_technical" method="POST" data-netlify="true">
            <input type="hidden" name="form-name" value="contact_technical" />
            <p>
              <label htmlFor="name_tech">Name:</label>
              <br />
              <input type="text" id="name_tech" name="name" />
            </p>
            <p>
              <label htmlFor="email_tech">Email:</label>
              <br />
              <input type="text" id="email_tech" name="email" />
            </p>
            <p>
              <label htmlFor="phone_tech">Phone:</label>
              <br />
              <input type="text" id="phone_tech" name="phone" />
            </p>
            <p>
              <label htmlFor="message_tech">Message:</label>
              <br />
              <textarea id="message_tech" name="message" />
            </p>
            <InputButton title="Submit" />
          </form>
        )
      }
      if (props.contact_type == '') {
        return <div />
      }
    }

    return (
      <div className={styles.outer}>
        <div className={styles.overlay} />
        <PageWrapper>
          <Helmet title="Contact - Dominion Systems, LLC" meta={[]} />
          <Inner>
            <div className={styles.wrapper}>
              <div className={styles.formColumn}>
                <TextContainer>
                  <h1>Contact Dominion Systems</h1>
                  <Divider />
                  <input
                    type="radio"
                    name="contact_type"
                    id="sales"
                    value="sales"
                    onChange={this.handleChange}
                    checked={this.state.contact_type === 'sales'}
                  />
                  <label htmlFor="sales">Sales</label>
                  <br />
                  <input
                    type="radio"
                    name="contact_type"
                    id="technical"
                    value="technical"
                    onChange={this.handleChange}
                    checked={this.state.contact_type === 'technical'}
                  />
                  <label htmlFor="technical">Technical</label>
                  <RenderForm contact_type={this.state.contact_type} />
                </TextContainer>
              </div>
              <div className={styles.infoColumn}>
                <TextContainer>
                  <Careers />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: this.props.data.contact.edges[0].node
                        .childMarkdownRemark.html,
                    }}
                  />
                  <h3>Connect</h3>
                  <p>
                    <a
                      className={styles.socialIcon}
                      href={
                        this.props.data.contact.edges[0].node
                          .childMarkdownRemark.frontmatter.facebook_url
                      }
                    >
                      <FaFacebookOfficial />
                    </a>
                  </p>
                </TextContainer>
              </div>
            </div>
          </Inner>
        </PageWrapper>
      </div>
    )
  }
}

export default ContactPage

export const pageQuery = graphql`
  query contactQuery {
    contact: allFile(filter: { sourceInstanceName: { eq: "contact" } }) {
      edges {
        node {
          id
          childMarkdownRemark {
            html
            frontmatter {
              title
              facebook_url
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/contact.js